//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



import UMUM from  '../../library/umum.js'
import uniqid from 'uniqid';

const stringOptions = [
  'Google', 'Facebook', 'Twitter', 'Apple', 'Oracle'
  ].reduce((acc, opt) => {
  for (let i = 1; i <= 5; i++) {
    acc.push(opt + ' ' + i)
  }
  return acc
}, [])

export default {
    data () {
        return {

            form : {
              id : '',
              kd_agama : '',
              uraian : '',
              createdAt : '',
            },

            list_data : [],

            page_limit : 8,
            page_first: 1,
            page_last: 0,
            cari_value: "",
            cek_load_data : true,



            current: 3,

            // mdl_add   : false,
            // mdl_edit  : false,

            mdl_add: false,
            mdl_edit: false,
            mdl_hapus : false,
            btn_add: false,
            
            nama : '',

        }
    },
    methods: {

      getView : function(){
        // this.$store.commit("shoWLoading");
        fetch(this.$store.state.url.URL_MASTER_SHDK + "view", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                data_ke: this.page_first,
                page_limit : this.page_limit,
                cari_value: this.cari_value
            })
        })
            .then(res => res.json())
            .then(res_data => {
                this.list_data = res_data.data;
                this.page_last = res_data.jmlData;
                // this.$store.commit("hideLoading");
                // console.log(res_data);
        });
      },


      addData : function(number) {
        var ID = uniqid();
        this.form.id  = ID;
        this.form.createdAt = UMUM.NOW();
        fetch(this.$store.state.url.URL_MASTER_SHDK + "addData", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(this.form)
        }).then(res_data => {
            this.$store.commit('notif_berhasil')
            this.getView();
        });
      },

        editData : function(){
            this.form.m_provinsi = this.form.m_provinsi;

            console.log();
            fetch(this.$store.state.url.URL_MASTER_SHDK + "editData", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify(this.form)
            }).then(res_data => {
                this.$store.commit('notif_edit');
                this.getView();
            });
        },

        removeData : function(E){
            fetch(this.$store.state.url.URL_MASTER_SHDK + "removeData", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify(E)
            }).then(res_data => {
                this.$store.commit('notif_berhasil_menghapus');
                this.getView();
            });

        },

        selectData(data){
            this.form = {
                id : data.id,
                kd_agama : data.kd_agama,
                uraian : data.uraian,
                createdAt : data.createdAt,
            };
        },

        indexing : function(index){
            var idx = ((this.page_first-1)*this.page_limit)+index
            return idx
        }, 
        abortFilterFn () {
        // console.log('delayed filter aborted')
        },
        counterLabelFn ({ totalSize, filesNumber, maxFiles }) {
            return `${filesNumber} files of ${maxFiles} | ${totalSize}`
        }
    },

    mounted () {
      this.getView();
    },
}
